var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0dbc775c953212b77ede89b4e3afde57bc95cf25"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["scanner@flicket-ltd"]={id:"0dbc775c953212b77ede89b4e3afde57bc95cf25"};
      